import { useScrollReveal } from "@/hooks/useScrollReveal"

export default function VisionSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section id="visao" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundColor: "#111" }}>
      {/* Decorative */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-10" style={{ backgroundColor: "#0E8EA0" }} />
        <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full opacity-10" style={{ backgroundColor: "#B038B2" }} />
      </div>

      <div ref={ref} className="relative z-10 max-w-4xl mx-auto px-5 text-center">
        <div
          className={`transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-8 leading-tight">
            Nossa <span style={{ color: "#F5C542" }}>visão</span>
          </h2>

          <p className="text-white/70 text-xl md:text-2xl leading-relaxed mb-6 font-light">
            Acreditamos que o futuro da educação em idiomas é{" "}
            <span className="font-bold" style={{ color: "#0E8EA0" }}>digital</span>,{" "}
            <span className="font-bold" style={{ color: "#B038B2" }}>flexível</span>,{" "}
            <span className="font-bold" style={{ color: "#6CC4C4" }}>personalizada</span> e{" "}
            <span className="font-bold" style={{ color: "#F5C542" }}>contínua</span>.
          </p>

          <p className="text-white/50 text-lg leading-relaxed max-w-2xl mx-auto">
            A English Work segue evoluindo para criar soluções cada vez mais
            inteligentes, acessíveis e conectadas com as necessidades reais
            do mercado e das pessoas.
          </p>
        </div>
      </div>
    </section>
  )
}
